<template>
  <div class="container-box-footer">
    <div class="row ml-0 mr-0">
      <div class="col-md-4 p-4 logo-section">
        <img
          :src="logoImgUrl"          
          width="190px"
          height="63px"
          alt="logo"
          class="ml-3 mt-2 logo-mipe"
        />
      </div>
      <div class="col-md-4 border-right mt-3 p-4 mb-3 message-section">
        <span class="contact-message">
          Para recibir asistencia comuníquese con nosotros.
        </span>
      </div>
      <div class="col-md-4 info-section">
        <footer-contact :contacts="catalog.contacts" />
      </div>
    </div>
  </div>
</template>

<script>
import FooterContact from './FooterContact';

import logoUrl from "@/assets/img/logo.svg";
import logoTrainingUrl from "@/assets/img/logo-training.svg"

export default {
  name: 'FooterContainer',
  components: {
    FooterContact,
  },
  data: () => ({
    catalog: {
      contacts: [
        {
          id: 1,
          type: 'phone',
          label: 'Contacto',
          icon: 'fa fa-phone-alt',
          references: [
            { id: 1, name: '787-773-6147', icon: 'fa fa-phone-alt' },
            { id: 2, name: '787-773-6147', icon: 'fa fa-phone-alt' },
          ],
        },
        {
          id: 2,
          type: 'email',
          label: 'Correo Electrónico',
          icon: 'fa fa-envelope',
          references: [
            {
              id: 1,
              name: 'asistencia-mipe@de.pr.gov',
              icon: 'fa fa-envelope',
            },
          ],
        },
      ],
    },
  }),
  computed: {
     logoImgUrl(){
      if(this.isTrainingEnv())
        return logoTrainingUrl;        
      return logoUrl;
    },
  }
};
</script>

<style scoped lang="scss">
.container-box-footer {
  background: #f2f2f2;

  .contact-message {
    text-align: left;
    font-style: italic;
    font: Medium Italic 20px/24px Lato;
    letter-spacing: 0px;
    color: #3f5b60;
    opacity: 1;
  }
}

@media only screen and (max-width: 768px) {
  .container-box-footer {
    .logo-section {
      width: 50%;
      padding: 20px 20px;
      margin-bottom: 10px;
      padding-left: 0px !important;
      .logo-mipe {
        height: 35pt;
        width: auto;
      }
    }
    .message-section {
      width: 50%;
      padding: 10px 20px 10px 5px !important;
      margin-top: 22px !important;
      border-right: none !important;
      text-align: center;
      span.contact-message {
        font-size: 0.8rem;
        line-height: 9pt;
        white-space: pre-wrap !important;
      }
    }
    .info-section {
      width: 100% !important;
      display: block !important;
      max-width: none !important;
      flex: none !important;
      margin-bottom: 15px;
      .contact-container {
        margin-top: -30px;
        display: flex !important;
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        ::v-deep .contact-box {
          width: 100% !important;
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-bottom: 0px;
          .icon-box {
            display: none !important;
          }
          .contact-label {
            display: none !important;
          }
          .references-box {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: -0px;
            div:nth-child(1) {
              span {
                margin-right: 10px;
              }
            }
            div:nth-child(2) {
              span {
                margin-left: 10px;
              }
              .phone-icon {
                display: none;
              }
              &::before {
                content: '/';
              }
            }
          }
        }
      }
    }
  }
}
</style>
